import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GeneralRequest } from '../../protos/accounts_pb';
import { AccountsServiceClient } from '../../protos/accounts_grpc_web_pb';
import { AccountsServerAddress } from '../../protos/server';
import GetMetadata from '../customComponents/getMetadata';

export function useGetContacts() {
    const [stat, setStat] = useState(2)
    const [contacts, setContacts] = useState([])

    const userData = useSelector(state => state.userData)
    const contactDetails = useSelector(state => state.contactDetails)

    const dispatch = useDispatch()
    const accClient = new AccountsServiceClient(AccountsServerAddress, null, null)
    var md = GetMetadata()

    const fetchContacts = (token) => {
        const req = new GeneralRequest();
        md.authorization = token

        accClient.getContactDetails(req, md, (err, response) => {
            if (err) {
                console.log(err)
                setStat(-1)
            } else {
                const res = response.toObject()
                dispatch({ type: 'SET_CONTACTS', contacts: res.contactsList });
                setContacts(res.contactsList)
                setStat(0)
            }
        })
    }

    useEffect(() => {
        if (contactDetails[0].contacttype === undefined) {
            fetchContacts(userData.token)
        } else {
            setContacts(contactDetails)
            setStat(0)
        }
    }, [])

    return [stat, contacts]
}